import { Trophy } from "@phosphor-icons/react";
import { useTranslation } from "@/contexts/LanguageContext";

export default function ProjectProgressSummary({ projectsDone, projectsTotal, itemsDone, itemsTotal }) {
  const { lang } = useTranslation();
  const es = lang === "es";
  const pct = itemsTotal ? Math.round((itemsDone / itemsTotal) * 100) : 0;
  return (
    <div className="bg-[#121214]/80 backdrop-blur-md border border-white/10 rounded-xl p-4 sm:p-5" data-testid="projects-progress-summary">
      <div className="flex items-center gap-3 flex-wrap">
        <div className="w-10 h-10 rounded-lg bg-[#F5A524]/10 flex items-center justify-center shrink-0">
          <Trophy weight="fill" className="w-5 h-5 text-[#F5A524]" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-[#71717A] text-[10px] uppercase tracking-[0.18em] font-semibold">
            {es ? "Tu progreso" : "Your progress"}
          </p>
          <p className="text-white text-sm sm:text-base font-medium">
            <span className="font-['JetBrains_Mono'] text-[#F5A524]" data-testid="progress-projects-count">{projectsDone}/{projectsTotal}</span>
            {es ? " proyectos completados · " : " projects completed · "}
            <span className="font-['JetBrains_Mono'] text-[#F5A524]" data-testid="progress-items-count">{itemsDone}/{itemsTotal}</span>
            {es ? " entregables" : " deliverables"}
          </p>
        </div>
        <span className="font-['JetBrains_Mono'] text-2xl text-white" data-testid="progress-percent">{pct}%</span>
      </div>
      <div className="mt-3 h-1.5 bg-white/5 rounded-full overflow-hidden">
        <div className="h-full bg-[#F5A524] rounded-full transition-[width] duration-500" style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}
